import { PostalCodeField, useFormField } from '@weave/design-system';
import { FC } from 'react';

export const BuilderPostalCode: FC<{}> = ({}) => {
  const fieldProps = useFormField({
    type: 'text',
  });
  return <PostalCodeField name={'postal-code'} label={''} {...fieldProps} />;
};
